'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';

import type { Product } from '@libs/common-types';

import { resolveFulfillmentMethod } from '../../product-details';
import { miniPdpFormSchema } from '../schema';
import type { MiniPdpForm } from '../types';

const getDefaultValues = (product?: Product, selectedSku = ''): MiniPdpForm => {
    const availableMethods = {
        bopis: Boolean(product?.deliveryMethods.BOPIS.availablePurchaseOptions.oneTime),
        sdd: Boolean(product?.deliveryMethods.SDD.availablePurchaseOptions.oneTime),
        sth: Boolean(product?.deliveryMethods.STH.availablePurchaseOptions.oneTime),
    };
    const fulfilmentMethod = resolveFulfillmentMethod({ availableMethods });
    const method = fulfilmentMethod.toUpperCase() as keyof Product['deliveryMethods'];

    return {
        selectedSku,
        fulfilmentMethod,
        quantity: product?.deliveryMethods[method].purchaseQuantities?.min ?? 1,
    };
};

export const useMiniPdpForm = (product?: Product, selectedSku = '') => {
    const form = useForm<MiniPdpForm>({
        defaultValues: getDefaultValues(product, selectedSku),
        resolver: zodResolver(miniPdpFormSchema),
    });

    useEffect(() => {
        form.reset(getDefaultValues(product, selectedSku));
        void form.trigger();
    }, [form, product, selectedSku]);

    return form;
};
